var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.091,
    height: 15,
    viewBox: "0 0 19.091 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24",
    d: "M26.216 12.443h-1.364V6.989H14.625V5.625h10.227a1.365 1.365 0 0 1 1.364 1.364z",
    transform: "translate(-7.125 -5.625)",
    style: {
      fill: "#1e0058"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25",
    d: "M20.591 18.068h-1.364v-5.454H9V11.25h10.227a1.365 1.365 0 0 1 1.364 1.364z",
    transform: "translate(-4.909 -7.841)",
    style: {
      fill: "#1e0058"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26",
    d: "M13.159 25.057H3.614a1.365 1.365 0 0 1-1.364-1.364v-5.454a1.365 1.365 0 0 1 1.364-1.364h9.545a1.365 1.365 0 0 1 1.364 1.364v5.455a1.365 1.365 0 0 1-1.364 1.364zm-9.545-6.818v5.455h9.546v-5.455z",
    transform: "translate(-2.25 -10.057)",
    style: {
      fill: "#1e0058"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/collapse-all.fa8c9c185694938a1e8dc9b8ae05174e.svg";
export { ForwardRef as ReactComponent };